import { ADDRESS_LINES, BRAND, HOURS, MAPS } from '@/constants';

export default function MapSection() {
  return (
    <section id="contact" className="py-16 px-6 scroll-mt-[84px] bg-[#f6f3ec]">
      <div className="max-w-[1180px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-[#0b6b52] text-xs font-semibold tracking-widest uppercase mb-3 block">
            Nous trouver
          </span>
          <h2
            className="text-[clamp(28px,4vw,40px)] font-bold text-[#173029] mb-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Notre Cabinet
          </h2>
          <p className="text-[#57534a] text-sm max-w-xl mx-auto leading-relaxed">
            Situé au cœur d&apos;{BRAND.city}, notre cabinet vous accueille dans un cadre calme et apaisant
            pour vos séances de Cupping Thérapie et Hijama.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">
          <div className="flex flex-col gap-3.5">
            <div className="bg-white border border-[#e8e2d4] rounded-2xl p-[22px] flex gap-4 items-start">
              <i className="ri-map-pin-2-line text-[#0b6b52] text-[22px] flex-shrink-0"></i>
              <div>
                <div className="font-semibold text-[14.5px] text-[#22201c] mb-1">Adresse</div>
                <div className="text-sm leading-relaxed text-[#57534a]">
                  {ADDRESS_LINES.street}
                  <br />
                  {ADDRESS_LINES.cityLine}
                  <br />
                  <span className="text-xs text-[#8a8578]">{ADDRESS_LINES.region}, France</span>
                </div>
              </div>
            </div>

            <div className="bg-white border border-[#e8e2d4] rounded-2xl p-[22px] flex gap-4 items-start">
              <i className="ri-time-line text-[#0b6b52] text-[22px] flex-shrink-0"></i>
              <div className="flex-1">
                <div className="font-semibold text-[14.5px] text-[#22201c] mb-2">Horaires d&apos;ouverture</div>
                {HOURS.rows.map((h) => (
                  <div
                    key={h.day}
                    className="flex justify-between text-[13px] text-[#57534a] py-0.5 gap-4"
                  >
                    <span>{h.day}</span>
                    <span
                      className={`font-semibold ${h.closed ? 'text-[#b0543f]' : 'text-[#0b6b52]'}`}
                    >
                      {h.hours}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white border border-[#e8e2d4] rounded-2xl p-[22px] flex gap-4 items-start">
              <i className="ri-phone-line text-[#0b6b52] text-[22px] flex-shrink-0"></i>
              <div>
                <div className="font-semibold text-[14.5px] text-[#22201c] mb-1">Contact</div>
                <div className="text-sm leading-relaxed text-[#57534a]">
                  <a href={`tel:${BRAND.phoneE164}`} className="text-[#0b6b52] font-semibold hover:text-[#08553f]">
                    {BRAND.phoneDisplay}
                  </a>
                  <br />
                  <a href={`mailto:${BRAND.email}`} className="text-[#0b6b52] hover:text-[#08553f]">
                    {BRAND.email}
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white border border-[#e8e2d4] rounded-2xl p-[22px] flex gap-4 items-start">
              <i className="ri-car-line text-[#0b6b52] text-[22px] flex-shrink-0"></i>
              <div>
                <div className="font-semibold text-[14.5px] text-[#22201c] mb-1">Accès</div>
                <ul className="space-y-1.5 mt-1">
                  <li className="flex items-center gap-2 text-[13px] text-[#57534a]">
                    <i className="ri-parking-box-line text-[#0b6b52] text-sm"></i>
                    Parking gratuit à proximité
                  </li>
                  <li className="flex items-center gap-2 text-[13px] text-[#57534a]">
                    <i className="ri-bus-line text-[#0b6b52] text-sm"></i>
                    Arrêt bus à 5 min à pied
                  </li>
                  <li className="flex items-center gap-2 text-[13px] text-[#57534a]">
                    <i className="ri-train-line text-[#0b6b52] text-sm"></i>
                    Gare d&apos;{BRAND.city} à 10 min
                  </li>
                </ul>
              </div>
            </div>

            <a
              href={MAPS.directions}
              target="_blank"
              rel="nofollow noopener"
              className="flex items-center justify-center gap-2 bg-[#0b6b52] hover:bg-[#0d7f61] text-white font-semibold text-sm py-3.5 rounded-[14px] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-navigation-line"></i>
              Obtenir l&apos;itinéraire
            </a>
          </div>

          <div className="rounded-[18px] overflow-hidden border border-[#e8e2d4] min-h-[440px]">
            <iframe
              title={`Cabinet ${BRAND.name} — ${ADDRESS_LINES.full}`}
              src={MAPS.embed}
              width="100%"
              height="100%"
              style={{ border: 'none', minHeight: '440px', display: 'block' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
